import React from 'react';

export default function Copiable({ txt, style, children }) {
  return (
    <span
      onClick={() => {
        navigator.clipboard.writeText(txt || children);
      }}
      style={{ ...style, cursor: 'pointer' }}
    >
      {children || txt}
    </span>
  );
}
